import {definePlugin} from 'sanity'
import {route} from 'sanity/router'
import CacheDashboard from './CacheDashboard'

export const cacheDashboard = definePlugin(() => ({
  name: 'sanity-plugin-cache-dashboard',
  tools: [
    {
      name: 'cache-dashboard',
      title: 'Cache Dashboard',
      component: CacheDashboard,
      router: route.create('/*'),
    },
  ],
}))
